import * as Yup from 'yup';

const CANCEL_REASONS = [
  'Decided not to buy a car right now',
  'Switching to another Carvana car',
  'Switching to another car',
  'No longer fits my budget',
  'Appointment date has been delayed',
  'Poor customer experience',
  'Found a car elsewhere',
  'Other'
] as const;

export default Yup.object().shape({
  reason: Yup.string().oneOf(CANCEL_REASONS).required(),
  otherReasonText: Yup.string()
});
